const DgHoldingsConstants = {
    Top: "A",
    New: "N",
    Inc: "I",
    Dec: "D",
    Unchg: "E",
    Closed: "C"
};

export default DgHoldingsConstants;